<template>
    <router-view v-if="$route.name === 'accountDetails' || $route.name === 'PossessionDetails'
        "></router-view>
    <content-view class="accountList" v-else>
        <tab-components-vue @tabNumChange="tabNumChange" :currentNumN="currentNumN"></tab-components-vue>

        <Sortingcenter v-if="currentNum == 0"></Sortingcenter>
        <!-- <Residentcenter v-if="currentNum == 1"></Residentcenter> -->
        <Toxiccenter v-if="currentNum == 1"></Toxiccenter>
        <MajorPossession v-if="currentNum == 2"></MajorPossession>

    </content-view>
</template>
<script>
import Sortingcenter from "./components/sortingcenter.vue";
import Residentcenter from "./components/residentcenter.vue";
import Toxiccenter from "./components/harmfulcenter.vue";
// 大件
import MajorPossession from "./components/major_possession.vue";

import tabComponentsVue from "../../components/common/tab.components.vue";
export default {
    name: "orderMergeList",
    data() {
        return {
            tabList: [
                {
                    name: "桐庐分拣中心",
                    id: "0",
                },
                {
                    name: "桐庐居民回收资源",
                    id: "1",
                },
                {
                    name: "桐庐有毒有害回收信息",
                    id: "2",
                },
                {
                    name: "大件回收订单",
                    id: "3",
                },
            ],
            visible: false,
            centerId: "",
            statusList: [
                {
                    name: "禁用",
                    value: "0",
                },
                {
                    name: "正常",
                    value: "1",
                },
            ],
            modalWidth: 434,
            visible: false,
            confirmLoading: false,
            block_id: "",
            // tabList: [{
            //     name: "桐庐有毒有害回收信息",
            //     id: "2"
            // }],
            currentNum: 0,
            currentNumN: 0,
        };
    },
    components: {
        tabComponentsVue,
        Sortingcenter,
        Residentcenter,
        Toxiccenter,
        MajorPossession,
    },
    computed: {},
    methods: {
        // tab切换点击
        tabClick(data, index) {
            
            this.currentNum = index;
        },
        // 接受组件的值
        tabNumChange(val) {
            this.currentNum = val;
            sessionStorage.removeItem("tongluSearchData");
        },
    },
    mounted() { },
    created() {
        // if(this.$route.query.tonglu){
        //     let value = {
        //         login: "0571311500",
        //         passwd: "123456"
        //     }
        //     this.$api.login
        //         .login(value)
        //         .then(res => {
        //             if(res.code > 0){
        //                 this.$message.error(res.msg);
        //                 // window.location.reload();
        //             }else{
        //                 localStorage.user = JSON.stringify(res.data);
        //                 localStorage._token = res.data.token;
        //             }
        //         })
        //         .catch(error => {
        //             console.log(error);
        //         })
        //         .finally(() =>{});
        // }
    },

    watch: {
        $route(to, from) {
            if (from.name == "PossessionDetails") {
                this.currentNumN = 2;
            }
        },
    },
};
</script>
<style rel="stylesheet/scss" lang="scss">
.wrap-cont-cover {
    flex: unset;
}

.wrap-container {
    flex: unset;
}

.wrap-container>div {
    flex: unset;
}

.accountList {
    &-tab {
        display: flex;

        &-list {
            width: 253px;
            height: 134px;
            background: url(../../assets/tabunlight.png) no-repeat;
            background-size: 100% 100%;
            color: #363e51;
            cursor: pointer;

            .content {
                margin-top: 20px;
                margin-left: 30px;
                font-size: 14px;

                &>div:nth-child(1) {
                    font-weight: bold;
                }

                &>div:nth-child(2) {
                    font-size: 12px;
                    margin-top: 10px;
                }
            }
        }

        .active {
            color: #ffffff !important;
            background: url(../../assets/tablight.png) no-repeat !important;
        }
    }
}</style>
